export const SlidersIcon = () => {
    return (
        <svg 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path 
                d="M6.75001 19L6.75001 12M17.25 19V12M11.9999 19V17.25M6.75001 6.75V5M6.75001 6.75C7.71652 6.75 8.50002 7.5335 8.50002 8.5C8.50002 9.4665 7.71652 10.25 6.75001 10.25C5.78351 10.25 5 9.4665 5 8.5C5 7.5335 5.78351 6.75 6.75001 6.75ZM17.25 6.75V5M17.25 6.75C18.2165 6.75 19 7.5335 19 8.5C19 9.4665 18.2165 10.25 17.25 10.25C16.2835 10.25 15.5 9.4665 15.5 8.5C15.5 7.5335 16.2835 6.75 17.25 6.75ZM11.9999 12L11.9999 5M11.9999 12C12.9665 12 13.75 12.7835 13.75 13.75C13.75 14.7165 12.9665 15.5 11.9999 15.5C11.0334 15.5 10.2499 14.7165 10.2499 13.75C10.2499 12.7835 11.0334 12 11.9999 12Z" 
                stroke="currentColor" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
        </svg>
    );
};
